import { toast } from 'react-toastify';

import { useCreateWalletTagMutation } from '@entities/wallet-tags';
import { useAssignWalletTagsMutation } from '@entities/wallets';

import { ITagOption } from '../components/WalletTagsSelect';

/**
 * Persists a wallet's tag selection. New tags (typed in the creatable select) are created first
 * (`POST /wallet-tags`), then the full desired id set is sent to `PUT /wallets/{id}/tags` —
 * which replaces the wallet's tags (ids not passed are removed).
 */
export const useAssignWalletTags = () => {
  const [createWalletTag] = useCreateWalletTagMutation();
  const [assignWalletTags] = useAssignWalletTagsMutation();

  const assignTags = async (walletId: string, selected: ITagOption[]): Promise<boolean> => {
    try {
      const tagIds: number[] = [];

      for (const option of selected) {
        if (option.__isNew__) {
          const created = await createWalletTag({ name: option.label.trim() }).unwrap();
          tagIds.push(created.data.id);
        } else {
          tagIds.push(Number(option.value));
        }
      }

      await assignWalletTags({ id: walletId, tag_ids: tagIds }).unwrap();
      return true;
    } catch (error) {
      const message =
        (error as { data?: { message?: string } })?.data?.message ?? 'Failed to save wallet tags';
      toast.error(message);
      return false;
    }
  };

  return { assignTags };
};
